import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { CustomEvent } from "schemas/functions";
import theme from "styles/theme";

import LocationAutocomplete from "components/LocationAutocomplete";
import { UserLocation } from "components/LocationAutocomplete/schema";

interface LocationDialogProps {
  open: boolean;
  handleClose: (latitude?: number, longitude?: number) => void;
}

export default function LocationDialog({
  open,
  handleClose,
}: LocationDialogProps) {
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [latitude, setLatitude] = useState<number | undefined>();
  const [longitude, setLongitude] = useState<number | undefined>();

  const handleLocationChange = (userLocation: UserLocation) => {
    setLatitude(userLocation.latitude);
    setLongitude(userLocation.longitude);
  };

  return (
    <Dialog
      onClick={(e: CustomEvent) => e.stopPropagation()}
      open={open}
      onClose={() => handleClose()}
      fullScreen={isMobileScreen}
    >
      <DialogTitle>
        <Grid container justifyContent="center">
          Where do you want to find local brands? ✨
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ p: 4 }}>
        <Box sx={{ mb: 2, zIndex: 50 }}>
          Fill out a <strong>location (zip, city, neighborhood, etc.)</strong>{" "}
          below to find brands near you.
        </Box>
        <LocationAutocomplete handleLocationChange={handleLocationChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()} color="secondary">
          Close
        </Button>
        <Button
          onClick={() => {
            handleClose(latitude, longitude);
          }}
        >
          Enter
        </Button>
      </DialogActions>
    </Dialog>
  );
}
